import { Component, ChangeDetectionStrategy, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import _get from 'lodash-es/get';
import _cloneDeep from 'lodash-es/cloneDeep';

import { GenericFieldset, IGenericFieldset } from '../generic-fieldset.component';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { faMoneyBill, faPercent, IconDefinition } from "@fortawesome/free-solid-svg-icons";

/**
 * Quantity-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({
    selector: 'price-fieldset',
    templateUrl: './price-fieldset.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriceFieldsetComponent extends GenericFieldset implements IGenericFieldset , OnChanges{
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'price';

    public iconMoney: IconDefinition= faMoneyBill;
    public iconPercent: IconDefinition= faPercent;

    public wording: ILabels = {
        priceParADT: Yii.t('wui-shared-js', 'Prix par adulte (EUR)'),
        tolerance: Yii.t('wui-shared-js', 'Tolérance'),
    };

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder) {
        super(fb);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        console.log(this.config)
        const newPrice: any = _get(changes, ['fieldsetData', 'currentValue']);
        if (newPrice) {
            //clone to avoid /100 propagation in search abstract
            const price = _cloneDeep(newPrice);

            if (price.value) {
                price.value = price.value / 100;
            }
            //inject
            const control = this.group;
            // timeout ==> sometimes value is not patch (#31816)
            setTimeout(() => {
                control.patchValue(price);
            }, 300);
        }
    }

}
